import styled, { keyframes } from 'styled-components';

import { Rarity } from '__generated__/globalTypes';

import custom_series from './assets/custom_series.jpg';
import limited from './assets/limited.jpg';
import rare from './assets/rare.jpg';
import super_rare from './assets/super_rare.jpg';
import unique from './assets/unique.jpg';

const Gradient = styled.div<{ background?: string }>`
  background: ${({ background }) => background && `url(${background})`};
  background-size: cover;
  background-position: center;
  position: absolute;
  inset: 0;
`;
const TopShadowGradient = styled.div`
  background: linear-gradient(
    180deg,
    rgba(16, 16, 16, 0.72) 0%,
    rgba(16, 16, 16, 0) 100%
  );
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 250px;
`;

const BottomShadowGradient = styled.div`
  background: linear-gradient(
    0deg,
    rgba(16, 16, 16, 0.64) 0%,
    rgba(16, 16, 16, 0) 100%
  );
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 150px;
`;

const gearAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const GearCtn = styled.div`
  position: absolute;
  top: 40%;
  left: 50%;
  max-height: 120%;
  overflow: hidden;
  transform: translate(-50%, -50%);
`;

const Gear = styled.svg`
  animation: ${gearAnimation} 165s linear infinite;
`;

const assets = {
  [Rarity.common]: undefined,
  [Rarity.custom_series]: custom_series,
  [Rarity.limited]: limited,
  [Rarity.rare]: rare,
  [Rarity.super_rare]: super_rare,
  [Rarity.unique]: unique,
};

export const Background = ({ rarity }: { rarity: Rarity }) => {
  return (
    <>
      <Gradient background={assets[rarity]} />
      <TopShadowGradient />
      <BottomShadowGradient />
      <GearCtn>
        <Gear
          width="971"
          height="971"
          viewBox="0 0 971 971"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity="0.16">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M698.049 167.282C635.175 125.289 561.171 102.801 485.447 102.801L485.561 102.686C384.023 102.801 286.728 143.188 215.02 214.896C143.311 286.72 102.811 384.014 102.811 485.438C102.811 561.048 125.183 635.051 167.29 698.04C209.283 761.029 269.059 810.02 339.047 839.047C408.92 868.075 485.906 875.648 560.139 860.847C634.371 846.046 702.524 809.561 756.104 756.095C809.684 702.63 846.055 634.363 860.855 560.13C875.656 485.898 867.969 409.026 839.056 339.038C810.028 269.165 761.038 209.389 698.049 167.282ZM215.708 81.8049C295.563 28.4538 389.415 0 485.447 0C614.293 0 737.747 51.1713 828.846 142.27C919.829 233.254 971 356.822 971 485.553C971 581.585 942.546 675.438 889.195 755.292C835.843 835.032 760.005 897.332 671.316 934.047C582.626 970.762 484.988 980.4 390.792 961.698C296.595 942.996 210.086 896.759 142.163 828.837C74.2416 760.914 28.0037 674.405 9.30165 580.209C-9.39916 486.012 0.237668 388.373 36.9526 299.684C73.6675 210.996 135.968 135.156 215.708 81.8049ZM548.786 353.494C509.547 336.514 475.128 310.125 448.395 276.852L448.624 276.967C447.477 275.59 446.1 274.672 444.494 274.099C443.589 273.84 442.648 273.691 441.71 273.671C440.984 273.656 440.261 273.719 439.56 273.869C437.954 274.214 436.348 275.132 435.2 276.279C434.053 277.541 433.135 279.032 432.791 280.638C422.58 322.172 402.501 360.608 374.162 392.619C345.823 424.63 310.026 449.183 270.098 464.327C268.492 464.901 267.115 465.933 266.083 467.31C265.05 468.573 264.361 470.179 264.247 471.9C264.19 472.762 264.247 473.625 264.405 474.458C264.563 475.288 264.821 476.089 265.165 476.833C265.853 478.325 267.115 479.587 268.492 480.505C304.748 502.992 335.038 533.97 356.722 570.8C378.407 607.515 390.798 649.049 392.864 691.73C392.978 693.45 393.437 695.057 394.47 696.434C395.503 697.811 396.765 698.843 398.371 699.532C399.977 700.22 401.583 700.449 403.304 700.22C404.154 700.05 404.977 699.795 405.744 699.457C406.529 699.111 407.256 698.677 407.894 698.154C440.593 670.504 479.488 651.229 521.25 641.935C563.013 632.642 606.383 633.789 647.687 645.033C648.154 645.166 648.63 645.261 649.111 645.316C650.283 645.453 651.48 645.358 652.62 645.033C654.227 644.574 655.718 643.656 656.866 642.394C658.013 641.132 658.816 639.641 659.046 637.919C659.275 636.313 659.16 634.592 658.472 632.986C642.294 593.403 635.984 550.607 640.114 508.041C644.245 465.475 658.587 424.515 681.992 388.833C682.91 387.456 683.484 385.735 683.484 384.014C683.484 382.293 683.025 380.571 682.107 379.08C681.189 377.588 679.927 376.441 678.321 375.638C676.715 374.72 674.994 374.491 673.273 374.72C630.706 377.818 587.911 370.59 548.786 353.494Z"
              fill="white"
            />
          </g>
        </Gear>
      </GearCtn>
    </>
  );
};
